import React from 'react';
import showOne from '../../../assets/images/resources_screen/tv_show_one.jpg';
import showTwo from '../../../assets/images/resources_screen/tv_show_two.jpg';
import resourcesImage from '../../../assets/images/home_screen/resources.webp';
import CustomDialog from '../../../components/CustomDialog';
import { IoClose } from 'react-icons/io5';

const Media = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState('');

  const showsData = [
    {
      img: showOne,
      link: 'https://www.youtube.com/embed/hzJgkrEVfb4?si=ud5Xj1ZX_zi7n4q9',
    },
    {
      img: showTwo,
      link: 'https://www.youtube.com/embed/IsuCKB8tqB8?si=pgwmwKcL6EJKx7Yq',
    },
  ];

  const handleVideoOpen = (link) => {
    setVideoLink(link);
    setModalOpen(true);
  };

  return (
    <div
      id="media"
      className="w-full flex flex-col gap-4 sm:gap-6 max-w-[1280px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10"
    >
      <h2 className="text-[38px] sm:text-[50px] 3xl:text-[70px] text-[#8258A4] font-bold leading-tight">
        Media
      </h2>
      <div className="flex flex-col lg:flex-row gap-4 md:gap-10 2xl:gap-20">
        <div className="flex-1 flex flex-col items-start gap-4">
          <h4 className="text-[24px] sm:text-[34px] text-[#8258A4] font-bold leading-tight">
            YOUTUBE CHANNEL
          </h4>
          <a
            href="https://www.youtube.com/@GuidepostPediatric"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={resourcesImage}
              alt="resourcesImage"
              className="[clip-path:inset(3px)]"
            />
          </a>
        </div>
        <div className="flex-1 flex flex-col items-start gap-4">
          <h4 className="text-[24px] sm:text-[34px] text-[#8258A4] font-bold leading-tight">
            TV SHOW
          </h4>
          <div className="flex flex-wrap md:flex-nowrap md:flex-row gap-4">
            {showsData.map((show, index) => {
              return (
                <img
                  key={index}
                  src={show.img}
                  onClick={() => handleVideoOpen(show.link)}
                  alt="resourcesImage"
                  className="[clip-path:inset(3px)] w-full lg:w-[49%] cursor-pointer hover:scale-105 transition-all duration-300"
                />
              );
            })}
          </div>
        </div>
      </div>

      <CustomDialog open={modalOpen} setOpen={setModalOpen}>
        <div className="w-full h-full flex items-center justify-center relative p-4">
          <IoClose
            onClick={() => setModalOpen(false)}
            className="absolute right-0 -top-4 md:-right-4 text-white text-4xl cursor-pointer z-50"
          />
          <iframe
            src={videoLink}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-[95vw] h-[400px] md:w-[84vw] md:max-h-[90vh] md:h-[700px] xl:w-[70vw] rounded-md shadow-lg"
          />
        </div>
      </CustomDialog>
    </div>
  );
};

export default Media;
